import React from 'react'
import { FormattedMessage } from 'react-intl'

import { SuperSource } from '@slite/search-client'

import { WebsiteCard } from '../../components/Card/Card'
import { useRoutes } from '../../routes'
import { StaticOrbiteScene } from './OrbiteScene/StaticOrbiteScene'

type WorkflowCardProps = {
  slug: string
  title: string
  estMinSaved: number | null
  sources: string[] | null
  className?: string
  size?: 'default' | 'large'
}

const isSuperSource = (value: string): value is SuperSource =>
  Object.values(SuperSource).includes(value as SuperSource)

export function WorkflowCard({
  slug,
  title,
  estMinSaved,
  sources,
  className,
  size = 'default',
}: WorkflowCardProps) {
  const routes = useRoutes()
  const orbitSources = (sources ?? []).filter(isSuperSource)

  const positionStyle: React.CSSProperties =
    size === 'large'
      ? { width: '150%', right: '20%' }
      : { width: '180%', right: '10%' }

  return (
    <WebsiteCard
      hoverOutline={false}
      className={[
        'flexbox flexbox-column overflow-hidden border-small border-alpha-shade-40 border-shade-05-on-hover',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      href={routes.workflows.detail({ slug })}
    >
      <div className="padding-horizontal-24 padding-top-24">
        {!!estMinSaved && (
          <span className="font-size-9 font-weight-semibold shade-20 margin-bottom-8 flexbox-inline">
            <FormattedMessage
              id="workflows.card.savedHours"
              defaultMessage="Save {savedHours}h/week"
              values={{ savedHours: Math.round(estMinSaved / 60) }}
            />
          </span>
        )}
        <h3 className="font-family-title font-weight-medium font-size-3 shade-05">
          {title}
        </h3>
      </div>
      <div
        className="position-relative margin-top-auto"
        style={{ minHeight: size === 'large' ? 280 : 180 }}
      >
        <StaticOrbiteScene
          sourceTypes={orbitSources}
          style={{ position: 'absolute', ...positionStyle }}
        />
      </div>
    </WebsiteCard>
  )
}
